import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/locals.actions';
import * as home from '../../../../actions/process.home.actions';
import { post } from '../../../../api/_basic';


import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Hidden from '@material-ui/core/Hidden';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';

import Menu from '../Menu';
import Editor from './Editor';

import { BlueTickIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function isOk(field) {
    return field === undefined || field.length < 2;
}

function isNotOkEmail(value) {
    return value ? !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) : false;
}

function isNotOkPhone(value) {
    return value ? !/^[(+34|0034|34)?[ -]*(6|7|8|9)[ -]*([0-9][ -]*){8}$/i.test(value) : false;
}


function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-employee"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}


class Index extends React.Component {

    state = {
        id: undefined,
        error: '',
        local: undefined,
        nombre: '',
        padres: '',
        direccion: '',
        telefono: '',
        contacto: '',
        email: '',
        sts: false,
        stsEncuesta: false,
        stsInformacion: '',
        codigoPublico: '',
        evitarCron: false,
        ruta: '',
        ciudad: '',
        codigopostal: '',
        provincia: '',
        pais: ''
    };

    constructor(props) {
        super(props);
        if (props.id) {
            props.loadInfo(props.id);
        }
    }

    componentDidMount() {
        const tools = [toolbar(this.handleSummit)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {

        const { local } = props;

        if (local !== state.local) {

            const { nombre, padres, direccion, telefono, contacto, email, sts, stsEncuesta, stsInformacion, codigoPublico, evitarCron, ciudad, codigopostal, provincia, pais } = local;
            state.nombre = nombre ? nombre : '';
            state.padres = padres ? padres : [];
            state.direccion = direccion ? direccion : '';
            state.telefono = telefono ? telefono : '';
            state.contacto = contacto ? contacto : '';
            state.email = email ? email : '';
            state.sts = sts ? sts : false;
            state.stsEncuesta = stsEncuesta ? stsEncuesta : false;
            state.stsInformacion = stsInformacion ? stsInformacion : '';
            state.codigoPublico = codigoPublico ? codigoPublico : '';
            state.evitarCron = evitarCron ? evitarCron : false;
            state.ciudad = ciudad ? ciudad : '';
            state.codigopostal = codigopostal ? codigopostal : '';
            state.provincia = provincia ? provincia : '';
            state.pais = pais ? pais : '';
            state.local = local;
            state.ruta = state
                .padres
                .reverse()
                .reduce((path, node) => {
                    if (!path) return node.nombre;
                    return path + ' > ' + node.nombre;
                }, '')
                .toUpperCase();

            return state;
        }
        return null;
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = async (event) => {
        if (event.target.name !== 'sts' || this.state.codigoPublico) {
            this.setState({ [event.target.name]: event.target.checked, edit: true });
        } else {
            this.setState({ [event.target.name]: event.target.checked, edit: true });
            const r = await post(`${process.env.REACT_APP_API}/sts`);
            this.setState({ codigoPublico: r });
        }

    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    handleSummit = () => {

        const { nombre, direccion, telefono, contacto, email, sts, stsEncuesta, stsInformacion, codigoPublico, evitarCron, ciudad, codigopostal, provincia, pais } = this.state;
        const local = {
            id: this.props.id,
            nombre: nombre,
            direccion: direccion,
            telefono: isNotOkPhone(telefono) ? '' : telefono,
            contacto: contacto,
            email: isNotOkEmail(email) ? '' : email,
            sts: sts,
            stsEncuesta: stsEncuesta,
            stsInformacion: stsInformacion,
            codigoPublico: codigoPublico,
            evitarCron: evitarCron,
            ciudad: ciudad,
            codigopostal: codigopostal,
            provincia: provincia,
            pais: pais
        }

        this.props
            .editLocalInfo(local)
            .then((r) => {
                this.props.history.push('/manage/locals');
            })
            .catch((error) => {
                console.error(error);
                this.setState({ error: error.message });
            });

    };



    render() {
        const { error, nombre, ruta, direccion, ciudad, codigopostal, provincia, pais, telefono, contacto, email, sts, stsEncuesta, stsInformacion, codigoPublico } = this.state;
        const { intl, info, id, locals_is_loading, locals_has_errored } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '81') &&
                info.security.licencias.some((f) => f.id === 157 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && locals_has_errored.hasErrored) {
            return <Error open type={locals_has_errored.hasErrored}  message={locals_has_errored.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {locals_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={error}
                            variant="error"
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full bg_white  overflow_y_scroll showbar padding_bottom_9 height100 bg_white '} onScroll={this.handleScroll}>
                        <div className="padding_borders">
                            <TextField
                                fullWidth
                                disabled={true}
                                id={'nombre'}
                                name={'nombre'}
                                error={isOk(nombre)}
                                label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                                className={'flex_full_row'}
                                value={nombre}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                disabled={true}
                                id={'ruta'}
                                name={'ruta'}
                                label={intl.formatMessage({ id: 'form_field_name_path' })}
                                className={'flex_full_row'}
                                value={ruta}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </div>
                        <hr className="margin_left_12 margin_right_12" />
                        <div className="flex_full_column padding_borders_flat bg_white">
                            <TextField
                                fullWidth
                                id={'direccion'}
                                name={'direccion'}
                                label={intl.formatMessage({ id: 'form_field_name_direction' })}
                                className={'flex_full_row'}
                                value={direccion}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'ciudad'}
                                name={'ciudad'}
                                label={intl.formatMessage({ id: 'form_field_name_city' })}
                                className={'flex_full_row'}
                                value={ciudad}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'codigopostal'}
                                name={'codigopostal'}
                                label={intl.formatMessage({ id: 'form_field_name_cp' })}
                                className={'flex_full_row'}
                                value={codigopostal}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'provincia'}
                                name={'provincia'}
                                label={intl.formatMessage({ id: 'form_field_name_province' })}
                                className={'flex_full_row'}
                                value={provincia}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'pais'}
                                name={'pais'}
                                label={intl.formatMessage({ id: 'form_field_name_country' })}
                                className={'flex_full_row'}
                                value={pais}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'telefono'}
                                name={'telefono'}
                                error={isNotOkPhone(telefono)}
                                helperText={
                                    isNotOkPhone(telefono)
                                        ? intl.formatMessage({ id: 'phone_format_error' })
                                        : ''
                                }
                                label={intl.formatMessage({ id: 'form_field_name_phone' })}
                                className={'flex_full_row'}
                                value={telefono}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'contacto'}
                                name={'contacto'}
                                label={intl.formatMessage({ id: 'form_field_name_contacto' })}
                                className={'flex_full_row'}
                                value={contacto}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'email'}
                                name={'email'}
                                error={isNotOkEmail(email)}
                                helperText={
                                    isNotOkEmail(email)
                                        ? intl.formatMessage({ id: 'email_format_error' })
                                        : ''
                                }
                                label={intl.formatMessage({ id: 'form_field_name_email' })}
                                className={'flex_full_row'}
                                value={email}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <div className="flex_full_row margin_top_32 align_center">
                                <div className="flex_full_column">
                                    <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                        <FormattedMessage id="form_field_name_sts" />
                                    </div>
                                </div>
                                <div className="flex_auto_column">
                                    <Switch
                                        name={'sts'}
                                        checked={sts}
                                        onChange={this.handleChecked}
                                        value="sts"
                                        color="primary"
                                    />
                                </div>
                            </div>
                            <TextField
                                fullWidth
                                id={'codigoPublico'}
                                name={'codigoPublico'}
                                disabled={true}
                                label={intl.formatMessage({ id: 'form_field_name_codigo' })}
                                className={'flex_full_row'}
                                value={codigoPublico}
                                margin="normal"
                            />
                            <div className="flex_full_row margin_top_32 align_center">
                                <div className="flex_full_column">
                                    <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                        <FormattedMessage id="form_field_name_sts_survey" />
                                    </div>
                                </div>
                                <div className="flex_auto_column">
                                    <Switch
                                        disabled={!sts}
                                        name={'stsEncuesta'}
                                        checked={stsEncuesta}
                                        onChange={this.handleChecked}
                                        value="stsEncuesta"
                                        color="primary"
                                    />
                                </div>
                            </div>
                            {
                                sts &&
                                <div className="flex_full_column margin_top_24">
                                    <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                        <FormattedMessage id="form_field_name_sts_information" />
                                    </div>
                                    <Editor
                                        {...this.props}
                                        id={randomstring()}
                                        name="stsInformacion"
                                        value={stsInformacion}
                                        disabled={!sts}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            }

                        </div>
                    </div>
                </div>
            );
        }
    }
}

Index.propTypes = {
    intl: intlShape.isRequired
};

const mapStateToProps = (state) => {
    return {
        locals_has_errored: state.locals_has_errored,
        locals_is_loading: state.locals_is_loading,
        local: state.localInfo,
        info: state.info
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/local/Index.js